
/* Desktop Product Images */
function addActiveClassOnScroll() {
  const divs = document.querySelectorAll('div[data-slide]');
  let lastActiveListItem = null;
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5
  };

  let observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      const listItem = document.querySelector(`li[data-slide="${entry.target.getAttribute('data-slide')}"]`);
      if(entry.isIntersecting) {
        if(lastActiveListItem) {
          lastActiveListItem.classList.remove('active');
        }
        listItem.classList.add('active');
        lastActiveListItem = listItem;
      }
    });
  }, options);

  divs.forEach(div => {
    observer.observe(div);
  });

  const listItems = document.querySelectorAll('li[data-slide]');
  listItems.forEach(listItem => {
    listItem.addEventListener('click', function() {
      const divToScrollTo = document.querySelector(`div[data-slide="${this.getAttribute('data-slide')}"]`);
      divToScrollTo.scrollIntoView({ behavior: 'smooth' });
    });
  });
}
addActiveClassOnScroll();

/* Custom image gallery */
const showGallery = document.querySelectorAll('.open-gallery');
const toggleGallery = (classes) => {
  classes.forEach((className) => {
    document.body.classList.toggle(className);
  });
};
showGallery.forEach((div) => {
  div.addEventListener('click', function() {
    toggleGallery(['product-gallery-open']);

    let dataAttribute = this.dataset.target;
    let matchingDiv = document.querySelector(`div[data-gallery-slide="${dataAttribute}"]`);

    if(matchingDiv) {
      matchingDiv.scrollIntoView({behavior: "smooth"});
    }
  });
});

document.querySelectorAll('.product-gallery__thumbnail').forEach(div => {
  div.addEventListener('click', function() {
      let dataThumbnail = this.getAttribute('data-thumbnail');
      let targetDiv = document.querySelector(`div[data-thumbnail="${dataThumbnail}"]`);
      if (targetDiv) {
          targetDiv.scrollIntoView({behavior: "smooth"});
      }
  });
});

const closeMediaProductGallery = document.querySelector('#close-media-product-gallery');
if (closeMediaProductGallery) {
  closeMediaProductGallery.addEventListener('click', function() {
    document.body.classList.remove('product-gallery-open');
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      document.body.classList.remove('product-gallery-open');
    }
});
}


